// Client column registry for the GTCO clients table. Schema-driven: GtTable renders
// whatever this declares. `sort` maps to a filters.js CLIENT_REGISTRY field.
export const CLIENT_COLUMNS = [
  { key: 'ref',           label: 'ID',        render: 'ref',       width: 120, frozen: true },
  { key: 'name',          label: 'Client',    render: 'client',    width: 240, frozen: true, sort: 'name' },
  { key: 'status',        label: 'Status',    render: 'clientstatus', width: 120, sort: 'status' },
  { key: 'sector',        label: 'Sector',    render: 'text',      width: 160, sort: 'sector' },
  { key: 'location',      label: 'Location',  render: 'text',      width: 150, sort: 'location' },
  // C1-CLIENTFACTS: company data
  { key: 'latest_funding', label: 'Latest round', render: 'text',   width: 130, sort: 'latest_funding' },
  { key: 'last_raised_at', label: 'Last raised',  render: 'ukdate', width: 115, sort: 'last_raised_at' },
  { key: 'employees',      label: 'Employees',    render: 'text',   width: 110, sort: 'employees' },
  { key: 'role_count',    label: 'Roles',     render: 'countpill', width: 90 },
  { key: 'contact_count', label: 'Contacts',  render: 'countpill', width: 100 },
  { key: 'created_at',    label: 'Added',     render: 'ukdate',    width: 110, sort: 'created_at' },
];

export const CLIENT_COLUMNS_EXTRA = [
  { key: 'website',     label: 'Website',   render: 'link',  width: 110 },
  { key: 'size',        label: 'Size',      render: 'text',  width: 100, sort: 'size' },
  { key: 'owner_name',  label: 'Owner',     render: 'text',  width: 150 },
  { key: 'has_brief',   label: 'Brief',     render: 'yesno', width: 90 },
  { key: 'updated_at',  label: 'Modified',  render: 'ukdate',width: 110, sort: 'updated_at' },
  { key: 'total_funding',         label: 'Total funding',  render: 'text', width: 130, sort: 'total_funding' },
  { key: 'latest_funding_amount', label: 'Round amount',   render: 'text', width: 130, sort: 'latest_funding_amount' },
  { key: 'annual_revenue',        label: 'Revenue',        render: 'text', width: 120, sort: 'annual_revenue' },
  { key: 'founded_year',          label: 'Founded',        render: 'text', width: 95,  sort: 'founded_year' },
  { key: 'technologies',          label: 'Technologies',   render: 'text', width: 240 },
];

export const ALL_CLIENT_COLUMNS = [...CLIENT_COLUMNS, ...CLIENT_COLUMNS_EXTRA];
